/* eslint-disable @typescript-eslint/no-require-imports, no-undef */
const { Platform } = require('react-native')
const { enableScreens } = require('react-native-screens')

if (Platform.OS === 'web' && typeof window !== 'undefined') {
  window.__TAGO_BOOT_PATHNAME = window.location.pathname
  window.__TAGO_BOOT_PATH =
    window.location.pathname + window.location.search + window.location.hash

  const canonicalHost = 'app.tago.rent'
  const host = window.location.hostname
  const isLocal =
    ['localhost', '127.0.0.1', '::1'].includes(host) ||
    /^10\./.test(host) ||
    /^192\.168\./.test(host) ||
    /^172\.(1[6-9]|2\d|3[0-1])\./.test(host)

  if (!isLocal && host !== canonicalHost) {
    window.location.replace(
      `https://${canonicalHost}${window.location.pathname}${window.location.search}${window.location.hash}`,
    )
  }
}

if (Platform.OS === 'android') {
  enableScreens(false)
}

require('expo-router/entry')
